import {
  CAMPAIGNDETAIL_LOADING,
  GET_CAMPAIGNDETAIL,
  GET_CAMPAIGNDETAIL_SUCCESS,
  GET_CAMPAIGNDETAIL_FAIL,
  ADD_CAMPAIGNDETAIL_SUCCESS,
  ADD_CAMPAIGNDETAIL_FAIL,
  DELETE_CAMPAIGNDETAIL_SUCCESS,
  DELETE_CAMPAIGNDETAIL_FAIL,
  UPDATE_CAMPAIGNDETAIL_SUCCESS,
  UPDATE_CAMPAIGNDETAIL_FAIL,
  CAMPAIGNDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  campaignDetails: [],
  error: {},
};

const CampaignDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CAMPAIGNDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CAMPAIGNDETAIL:
          return {
            ...state,
            campaignDetails: action.payload.data,
            isCampaignDetailCreated: false,
            isCampaignDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CAMPAIGNDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_CAMPAIGNDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCampaignDetailCreated: false,
            isCampaignDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CAMPAIGNDETAIL: {
      return {
        ...state,
        isCampaignDetailCreated: false,
        loading: true,
      };
    }

    case CAMPAIGNDETAIL_LOADING: {
      return {
        ...state,
        isCampaignDetailCreated: false,
        loading: true,
      };
    }

    case ADD_CAMPAIGNDETAIL_SUCCESS:
      return {
        ...state,
        isCampaignDetailCreated: true,
        loading: false,
        campaignDetails: [action.payload.data, ...state.campaignDetails],
      };

    case ADD_CAMPAIGNDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CAMPAIGNDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isCampaignDetailCreated: true,
        campaignDetails: state.campaignDetails.filter(
          campaignDetail => campaignDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CAMPAIGNDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CAMPAIGNDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isCampaignDetailCreated: true,
        campaignDetails: state.campaignDetails.map(campaignDetail =>
          campaignDetail.id.toString() === action.payload.data.id.toString() ? { ...campaignDetail, ...action.payload.data } : campaignDetail
        ),
      };

    case UPDATE_CAMPAIGNDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CAMPAIGNDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CampaignDetail;